export const getToken = () => sessionStorage.getItem("token")
export const setToken = (token) => sessionStorage.setItem("token", token)
export const removeToken = () => sessionStorage.removeItem("token")
export const clearSession = () => sessionStorage.clear();

export const isAuth = () => Boolean(getToken())

export const SIZES = [{ label: "S", value: "S" }, { label: "M", value: "M" }, { label: "L", value: "L" }, { label: "XL", value: "XL" }, { label: "XXL", value: "XXL" }];


export const isFileSizeValid = (file, maxSizeMB) => {
  const fileSizeMB = file.size / (1024 * 1024); // Convert bytes to MB
  return fileSizeMB <= maxSizeMB;
}